
var initEvents = function() {
    $(document).on('change', '.compare-shades-filter-row .variation-filter-dropdown-values select.variation-filter-selects', function (e) {
    	e.preventDefault();
    	var selectedFilterValue = $(this).val();
    	
    	$('.compare-shades-content li.compare-shades-image-tile').hide().filter('.'+selectedFilterValue).show();
    });

    $(document).on('change', '.product-detail .product-info-content .variation-filter-dropdown-values select.variation-filter-selects', function (e) {
        e.preventDefault();
        setCollapsedView($(this).val());
    });
    
}

var setCollapsedView = function(selectedFilterValue) {
    var threshold = 40;
	
    var $variants_container = $('.product-variations .product-variation-swatch-lists #pdp-swatches');
    var $variants_filtered;
    if(selectedFilterValue) {
        $variants_filtered = $variants_container.find('li:not(.view-all)').removeClass('swatch-item-extra').addClass('hide').filter('.'+selectedFilterValue).removeClass('hide');
    } else {
        $variants_filtered = $variants_container.find('li:not(.view-all)').removeClass('swatch-item-extra hide');
    }
	
    $variants_filtered.filter(':gt('+(threshold-1)+')').addClass('swatch-item-extra');
	
    $variants_container.removeClass('expanded').find('.view-all').toggleClass('hide', $variants_filtered.length <= threshold);
}


export default function () {
    initEvents();
    setCollapsedView();
};
